import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { TowRequestStoreEffects } from './effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature('towRequest', reducer),
        EffectsModule.forFeature([TowRequestStoreEffects])
    ],
    providers: []
})
export class TowRequestStoreModule {}
